module.exports = __webpack_public_path__ + "img/levis_726.a4128db7.png";